export default "__VITE_ASSET__DCVJF58Q__"